import React from 'react';
import {
  Box,
  Flex,
  Text,
  IconButton,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  useDisclosure,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import AdminSidebar from './AdminSidebar';
import { apiUrl } from '../ApiUrl/ApiUrl';
import AdminSubCategories from './AdminSubCategories';
function AdminCategories() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const maincatname = e.target.maincatname.value.trim(); // Trim to avoid empty spaces
  
    if (!maincatname) {
      alert('Category name is required!');
      return;
    }
  
    const requestData = { maincatname };
    console.log('Sending request data:', requestData); // Debugging log
  
    try {
      const response = await fetch(`${apiUrl}/public/saveCategories`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });
  
      // Handle 400 Bad Request explicitly
      if (response.status === 400) {
        const errorText = await response.text(); // Read plain text error
        console.log('400 Error received:', errorText); // Debugging log
        if (errorText.trim() === "This category already present") {
          alert('Category name already exists! Please use a different name.');
        } else {
          alert(`Error: ${errorText}`);
        }
        return;
      }
  
      // If response is OK, parse JSON and show success message
      if (response.ok) {
        const responseData = await response.json();
        alert(`Category "${responseData.maincatname}" has been successfully added!`);
        e.target.reset();
      } else {
        const errorText = await response.text();
        alert(`Error: ${errorText || 'Failed to add category'}`);
      }
    } catch (error) {
      console.error('Error adding category:', error);
      alert('An unexpected error occurred. Please try again later.');
    }
  };
  const handleBoundSubmit = async (e) => {
    e.preventDefault();
    const boundYear = e.target.savebondyear.value.trim(); // Fetch input value
  
    if (!boundYear) {
      alert("Bound year is required!");
      return;
    }
  
    try {
      // Send boundYear as a query parameter in the URL
      const response = await fetch(`${apiUrl}/public/savebondyear?bvy=${boundYear}`, {
        method: "POST",
      });
  
      if (!response.ok) {
        const errorText = await response.text();
        alert(`Error: ${errorText || "Failed to add Bound Year"}`);
        return;
      }
  
      const data = await response.text(); // Expecting a plain string ("success")
      alert(`Bound Year "${boundYear}" added successfully!`);
      e.target.reset();
    } catch (error) {
      console.error("Error:", error);
      alert("An unexpected error occurred.");
    }
  };
  
  
  
  
  

  return (
    <Flex h="100vh" bg="gray.100">
      {/* Sidebar */}
      <AdminSidebar />

      {/* Content Area */}
      <Box flex="1" p={4}>
        {/* Header */}
        <Flex
          justify="space-between"
          align="center"
          bg="white"
          p={4}
          mb={4}
          borderRadius="md"
          shadow="sm"
        >
          <IconButton
            icon={<FiMenu />}
            aria-label="Open menu"
            display={{ base: 'block', md: 'none' }}
            onClick={onOpen}
          />
          <Text fontSize="xl" fontWeight="bold">
            Categories Management
          </Text>
        </Flex>

        {/* Form Section */}
        <Box bg="white" p={6} borderRadius="md" shadow="sm">
          <Text fontSize="lg" fontWeight="bold" mb={4}>
            Add New Category
          </Text>
          <form onSubmit={handleFormSubmit}>
            <VStack spacing={4} align="stretch">
              <FormControl id="maincatname" isRequired>
                <FormLabel>Category Name</FormLabel>
                <Input
                  type="text"
                  placeholder="Enter category name"
                  name="maincatname"
                />
              </FormControl>
              <Button type="submit" colorScheme="teal" width="full">
                Add Category
              </Button>
            </VStack>
          </form>
        </Box>
        <hr />



        {/* <Box bg="white" p={6} borderRadius="md" shadow="sm">
    <Text fontSize="lg" fontWeight="bold" mb={4}>
      Add Bound Year (Ex: 2013-2019)
    </Text>
    <form onSubmit={handleBoundSubmit}>
      <VStack spacing={4} align="stretch">
        <FormControl id="savebondyear" isRequired>
          <Input type="text" placeholder="Ex: 2013-2019" name="savebondyear" />
        </FormControl>
        <Button type="submit" colorScheme="teal" width="full">
          Save
        </Button>
      </VStack>
    </form>
  </Box> */}



        {/* <Box mt={6}>
          <img 
            src="https://navneetlawstudio.com/images/cf546227-d61b-4e26-ba29-49a5e696e209_qr-code.png" 
            alt="QR Code"
            style={{ width: '100%', height: 'auto' }}
          />
        </Box> */}
      </Box>
      <AdminSubCategories />
        </Flex>
  );
}

export default AdminCategories;
